(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mutae-card-video')) {
    const cards = new Set();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection;
    let suspended = false;
    const syncCards = () => cards.forEach((card) => card.syncPlayback());
    const observer = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          for (const entry of entries) {
            entry.target.inViewport = entry.isIntersecting && entry.intersectionRatio >= 0.2;
            entry.target.syncPlayback();
          }
        }, { threshold: [0, 0.2] })
      : null;

    document.addEventListener('visibilitychange', syncCards);
    reducedMotion.addEventListener('change', syncCards);
    connection?.addEventListener('change', syncCards);
    window.addEventListener('pagehide', () => { suspended = true; syncCards(); });
    window.addEventListener('pageshow', () => { suspended = false; syncCards(); });

    class MutaeCardVideo extends HTMLElement {
      inViewport = false;
      #video = null;
      #slide = null;
      #slideObserver = null;
      #pending = false;
      #request = 0;

      connectedCallback() {
        cards.add(this);
        this.#slide = this.closest('slideshow-slide');
        this.#slideObserver = new MutationObserver(() => this.syncPlayback());
        if (this.#slide) {
          this.#slideObserver.observe(this.#slide, {
            attributes: true,
            attributeFilter: ['aria-hidden', 'hidden'],
          });
        }
        observer?.observe(this);
      }

      disconnectedCallback() {
        cards.delete(this);
        observer?.unobserve(this);
        this.#slideObserver?.disconnect();
        this.inViewport = false;
        this.#pause();
        if (this.#video) {
          this.#video.removeAttribute('src');
          this.#video.load();
          this.#video.remove();
          this.#video = null;
        }
      }

      #shouldPlay() {
        return this.isConnected && this.inViewport && !document.hidden && !suspended &&
          !reducedMotion.matches && !connection?.saveData &&
          !this.#slide?.hidden && this.#slide?.getAttribute('aria-hidden') !== 'true';
      }

      #pause() {
        this.#request += 1;
        this.#pending = false;
        this.#video?.pause();
        this.removeAttribute('data-playing');
      }

      #loadVideo() {
        const video = this.querySelector('template')?.content.querySelector('video')?.cloneNode(true);
        if (!video) return null;
        const sources = Array.from(video.querySelectorAll('source')).sort(
          (a, b) => Number(a.dataset.width) - Number(b.dataset.width)
        );
        const targetWidth = Math.min(this.clientWidth * Math.min(window.devicePixelRatio || 1, 2), 1200);
        const source = sources.find((item) => Number(item.dataset.width) >= targetWidth) || sources.at(-1);
        if (!source) return null;
        const url = source.getAttribute('src');
        sources.forEach((item) => item.remove());
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.src = url;
        video.addEventListener('error', () => this.#pause());
        this.append(video);
        return video;
      }

      syncPlayback() {
        if (!this.#shouldPlay()) {
          this.#pause();
          return;
        }
        if (this.#pending || (this.#video && !this.#video.paused)) return;
        this.#video ||= this.#loadVideo();
        if (!this.#video) return;
        const video = this.#video;
        const request = ++this.#request;
        this.#pending = true;
        video.play().then(() => {
          if (!this.#shouldPlay()) {
            video.pause();
          } else if (request === this.#request) {
            this.setAttribute('data-playing', '');
          }
        }).catch(() => {
          if (request === this.#request) this.removeAttribute('data-playing');
        }).finally(() => {
          if (request === this.#request) this.#pending = false;
        });
      }
    }

    customElements.define('mutae-card-video', MutaeCardVideo);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-information-content"] && !Shopify.designMode) return;
  try {
    class ProductScrollBoundary extends HTMLElement {
    #root;
    #media;
    #details;
    #content;
    #query = window.matchMedia('(min-width: 750px)');
    #touchQuery = window.matchMedia('(any-pointer: coarse)');
    #resize = new ResizeObserver(() => this.#update());
    #mutations = new MutationObserver(() => this.#observeContent());

    connectedCallback() {
      this.#root = this.closest('.product-information--independent');
      this.#media = this.#root?.querySelector('.product-information__media');
      if (!this.#media) return;
      this.#details = this.#root.querySelector('.product-details');

      this.#media.addEventListener('scroll', this.#update, { passive: true });
      this.#details?.addEventListener('keydown', this.#guardKeyboard);
      this.#query.addEventListener('change', this.#update);
      this.#touchQuery.addEventListener('change', this.#update);
      window.addEventListener('pageshow', this.#update);
      this.#resize.observe(this.#media);
      this.#mutations.observe(this.#media, { childList: true });
      this.#observeContent();
    }

    disconnectedCallback() {
      this.#media?.removeEventListener('scroll', this.#update);
      this.#details?.removeEventListener('keydown', this.#guardKeyboard);
      this.#query.removeEventListener('change', this.#update);
      this.#touchQuery.removeEventListener('change', this.#update);
      window.removeEventListener('pageshow', this.#update);
      this.#resize.disconnect();
      this.#mutations.disconnect();
      this.#root?.removeAttribute('data-gallery-at-end');
      this.#content = null;
    }

    #observeContent = () => {
      if (this.#content) this.#resize.unobserve(this.#content);
      this.#content = this.#media.firstElementChild;
      if (this.#content) this.#resize.observe(this.#content);
      this.#update();
    };

    #update = () => {
      if (!this.#media) return;
      const remaining = this.#media.scrollHeight - this.#media.clientHeight - this.#media.scrollTop;
      this.#root.toggleAttribute('data-gallery-at-end', this.#query.matches && !this.#touchQuery.matches && remaining <= 1);
    };

    #guardKeyboard = (event) => {
      if (!this.#query.matches || this.#touchQuery.matches || this.#root.hasAttribute('data-gallery-at-end')) return;
      if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey) return;
      if (event.target.closest('input, textarea, select, [contenteditable]:not([contenteditable="false"])')) return;
      const down = ['ArrowDown', 'PageDown', 'End'].includes(event.key)
        || (event.key === ' ' && !event.shiftKey && !event.target.closest('button, a, summary'));
      if (down && this.#details.scrollHeight - this.#details.clientHeight - this.#details.scrollTop <= 1) {
        event.preventDefault();
      }
    };
  }

  if (!customElements.get('product-scroll-boundary')) {
    customElements.define('product-scroll-boundary', ProductScrollBoundary);
  }
  } catch(e) { console.error(e); }
})();

})();
